import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/css-loader/dist/runtime/api.js'
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('ds-multi-checkbox', wrap(Vue, () => import('~root/src/components/forms/checkbox/multiCheckbox/MultiCheckbox.vue?shadow')))

window.customElements.define('ds-checkbox', wrap(Vue, () => import('~root/src/components/forms/checkbox/checkbox/Checkbox.vue?shadow')))

window.customElements.define('ds-tooltip', wrap(Vue, () => import('~root/src/components/tooltip/Tooltip.vue?shadow')))

window.customElements.define('ds-modal', wrap(Vue, () => import('~root/src/components/modal/Modal.vue?shadow')))

window.customElements.define('ds-ribbon', wrap(Vue, () => import('~root/src/components/ribbon/Ribbon.vue?shadow')))

window.customElements.define('ds-ribbon-item', wrap(Vue, () => import('~root/src/components/ribbon/ribbon-item/RibbonItem.vue?shadow')))

window.customElements.define('ds-auto-suggest', wrap(Vue, () => import('~root/src/components/forms/autoSuggest/autoSuggest/AutoSuggest.vue?shadow')))

window.customElements.define('ds-accordion', wrap(Vue, () => import('~root/src/components/accordion/Accordion.vue?shadow')))

window.customElements.define('ds-accordion-item', wrap(Vue, () => import('~root/src/components/accordion/accordion-item/AccordionItem.vue?shadow')))

window.customElements.define('ds-search', wrap(Vue, () => import('~root/src/components/forms/search/search/Search.vue?shadow')))

window.customElements.define('ds-date-picker', wrap(Vue, () => import('~root/src/components/forms/datePicker/DatePicker.vue?shadow')))

window.customElements.define('ds-inline-alert', wrap(Vue, () => import('~root/src/components/inlineAlert/InlineAlert.vue?shadow')))

window.customElements.define('ds-app-alert', wrap(Vue, () => import('~root/src/components/appAlert/AppAlert.vue?shadow')))

window.customElements.define('ds-form', wrap(Vue, () => import('~root/src/components/forms/form/Form.vue?shadow')))

window.customElements.define('ds-input', wrap(Vue, () => import('~root/src/components/forms/input/Input.vue?shadow')))